module.exports = __webpack_public_path__ + "src/img/smaller.2537415c.svg";